import * as React from 'react';
import { SVGProps } from 'react';

const SvgCalendarSimpleOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.275 3.862c0-.476-.4-.862-.895-.862-.494 0-.895.386-.895.862v.765H9.518v-.765c0-.476-.4-.862-.895-.862-.494 0-.895.386-.895.862v.765H6.383C4.791 4.627 3.5 5.871 3.5 7.404V18.223C3.5 19.757 4.79 21 6.383 21h11.234c1.592 0 2.883-1.243 2.883-2.777V7.404c0-1.533-1.29-2.777-2.883-2.777h-1.342v-.765ZM18.71 9.51V7.404c0-.582-.49-1.053-1.094-1.053h-1.342v.766c0 .476-.4.862-.895.862-.494 0-.895-.386-.895-.862v-.766H9.518v.766c0 .476-.4.862-.895.862-.494 0-.895-.386-.895-.862v-.766H6.383c-.604 0-1.094.471-1.094 1.053v2.107H18.71ZM5.288 11.234H18.71v6.99c0 .581-.49 1.053-1.093 1.053H6.383c-.604 0-1.094-.472-1.094-1.054v-6.989Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgCalendarSimpleOutlined;
